import React, { useEffect, useState } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import SacChatHeader from './sacChatHeader';
import QeeChatEmbedded from './qeeChatEmbedded';
import { markChatRead } from '../api/service';
import { getSac, getChatSac } from '../api/service'; 

const UsrChat = ({ chat, onChatUpdate }) => {
    const theme = useTheme(); 
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const [sac, setSac] = useState(null); // State to store the sac data
    const [isSacChat, setIsSacChat] = useState(false); // State to check if it's a SAC chat

    useEffect(() => {
        const usr = JSON.parse(sessionStorage.getItem('usr'));
        if (!usr) {
            console.error('No user data!');
            return;
        }

        // Mark the chat as read
        const markRead = async () => {
            let ret = await markChatRead(usr.usrId, chat.id);
            if (!ret.err && onChatUpdate) {
                onChatUpdate();
            }
        };

        markRead();

        // Check if chat_fac_id is in the format "sac-{id}"
        const [form, sacId] = chat.chat_fac_id.split('-');
        if (form === 'sac' && sacId) {
            setIsSacChat(true);
            // Fetch the sac document from Firebase
            const fetchSac = async () => {
                const sacDoc = await getSac( sacId); // Fetch the SAC document using sacId
                if (sacDoc) {
                    setSac(sacDoc);
                }
            };
            fetchSac();
        } else {
            setIsSacChat(false); // Not a SAC chat, so no need to fetch sac
        }
    }, [chat, onChatUpdate]);

    // Determine props based on form type
    const commonProps = {
        instanceName: `qeeleaapp-chat-${chat.chat_fac_id.split('-')[0].toLowerCase()}`,
        isP2P: chat.isP2P,
        showDateTime: true,
        showDate: true,
        showTime: true,
        height: isXs ? "calc(100svh - 60px)" : "90vh",
        style: { height: isXs ? "calc(100svh - 60px)" : "90vh" }
    };

    const parentProps = chat.chat_fac_id.split('-')[0] !== 'SESS' ? { parentForm: chat.chat_fac_id.split('-')[0], parentId: chat.chat_fac_id.split('-')[1] } : {};

    return (
        <>
            {isSacChat && sac && <SacChatHeader sac={sac} />}
            <QeeChatEmbedded 
                {...commonProps}
                {...parentProps}
            />
        </>
    );
};

export default UsrChat;
